interface ShowArchivedToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export default function ShowArchivedToggle({ checked, onChange }: ShowArchivedToggleProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '16px' }}>
      <span style={{ fontSize: '14px', fontWeight: 500 }}>Show Archived</span>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label="Show archived tasks"
        onClick={() => onChange(!checked)}
        style={{
          width: '36px',
          height: '20px',
          borderRadius: '10px',
          border: 'none',
          padding: '2px',
          cursor: 'pointer',
          backgroundColor: checked ? '#28a745' : '#ccc',
          transition: 'background-color 0.2s',
          display: 'flex',
          alignItems: 'center',
          flexShrink: 0,
        }}
      >
        <span
          style={{
            width: '16px',
            height: '16px',
            borderRadius: '50%',
            backgroundColor: '#fff',
            transition: 'transform 0.2s',
            transform: checked ? 'translateX(16px)' : 'translateX(0)',
            display: 'block',
          }}
        />
      </button>
    </div>
  );
}
